<template>
  <div class="container">
    <div class="top">
      <router-link to="/appraisal/info">
        <el-button type="primary" id="send_btn" size="mini">新建测试</el-button>
      </router-link>
      <el-input v-model="searchID" placeholder="请输入测试名称或ID" style="width: 200px; margin-right: 30px;"
        size="mini"></el-input>
      <!-- <el-select v-model="select1" placeholder="是否有体验营过期">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <el-select v-model="query.status" placeholder="测试状态" size="mini">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="query.give_camp_type" placeholder="关联课程方式" size="mini">
        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="serchListHandel" size="mini">搜索</el-button>
      <el-button type="primary" id="relevance" @click="dialogHandel" size="mini">批量设置关联体验营</el-button>
      <copyLink class="copylink" url="https://wap.zhangdefenspace.com/appPage/testIndex.html?source=" buttonName="推广测试大厅"
        @click="handel('https://wap.zhangdefenspace.com/appPage/testIndex.html?source=')"></copyLink>
      <!-- <el-switch v-model="isOpen" @change="addwatchHandel"> </el-switch>
      <div class="tisps">开启后所有测试活动小程序加微生效（如果填写），关闭则对所有测试的小程序加微方式不生效</div> -->
    </div>
    <div class="main">
      <el-table :data="tableData" border :stripe="true" style="width: 100%; margin: 10px 0" align="center">
        <el-table-column fixed label="测试id" id="send_id" align="center" width="80px">
          <template slot-scope="scope">
            <div class="flexs">
              <div class="flexstop">
                <span>{{ scope.row.id }}</span>
                <span style=" font-size: 14px; display: inline-block; background-color: #169BD5;"
                  class="res_type">{{ scope.row.result_type === 1 ? "随机" : scope.row.result_type === 2 ? "分数" : "维度"
                  }}</span>
              </div>
              <!-- <div class="noperformance" v-if="!scope.row.icombinedProp.create_status">
                    (未创建)
                  </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed label="图片" id="send_img" align="center" width="80px">
          <template slot-scope="scope">
            <img :src="scope.row.img_url" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="title" label="测试名称" align="center" width="200px"></el-table-column>
        <el-table-column prop="date" label="测试关联课程" align="center" width="400px">
          <template slot-scope="scope">
            <span v-for="course in scope.row.course_list" :key="course.id" style="display: block; width: 93%;">{{ course
              }}</span>
            <span class="Tyy_type" :style="{ 'background-color': scope.row.give_camp_type === 1 ? '#aaa' : 'coral' }">{{
              scope.row.give_camp_type == 1 ?'单独':'批量' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" width="180px"></el-table-column>
        <el-table-column label="参与人次" align="center" width="80px">
          <template slot-scope="scope">
            <router-link :to="`/appraisal/record?id=${scope.row.id}`">
              <span>{{ scope.row.test_num }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="receive_camp_num" label="领取数" align="center" width="70px"></el-table-column>
        <el-table-column fixed="right" label="操作" class="buttonbox">
          <template slot-scope="scope">
            <copyLink :url="scope.row.share_url" buttonName="推广" @click="handel(scope.row.share_url)"></copyLink>
            <router-link :to="`/appraisal/info?id=${scope.row.id}`" class="bianju">
              <el-button type="primary" size="mini">基本信息</el-button>
            </router-link>
            <router-link :to="`/appraisal/topic?id=${scope.row.id}&type=${scope.row.result_type}`" class="bianju">
              <el-button type="primary" size="mini">题目配置</el-button>
            </router-link>
            <router-link :to="`/appraisal/result?id=${scope.row.id}&type=${scope.row.result_type}`" class="bianju">
              <el-button type="primary" size="mini">结果配置</el-button>
            </router-link>
            <el-button type="primary" size="mini" @click="dialogVisibleHandel(scope.row.id)"
              class="bianju">分享海报设置</el-button>
            <el-button type="success" size="mini" @click="updateOnline(scope.row.id, 'online')" v-if="!scope.row.status"
              class="bianju">上架</el-button>
            <el-button type="danger" size="mini" v-if="!scope.row.status" @click="deleteHandel(scope.row.id)"
              class="bianju">删除</el-button>
            <el-button type="danger" size="mini" v-if="scope.row.status" @click="updateOnline(scope.row.id, 'offline')"
              class="bianju">下架</el-button>
            <el-button type="primary" size="mini" @click="setIsHide(scope.row.id, scope.row.is_hide == 1 ? 0 : 1)"
              class="bianju">{{ scope.row.is_hide == 1 ? '已隐藏' : '已显示' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bott">
      <el-pagination background layout="prev, pager, next" :total="totalItems" :page-size="pageSize"
        :current-page="currentPage" @current-change="handlePageChange">
      </el-pagination>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-radio-group v-model="radio">
        <el-radio :label="1">系统样式</el-radio>
        <el-radio :label="2">自定义样式</el-radio>
      </el-radio-group>
      <div class="img1" v-if="radio == 1">
        <img src="https://res.defen.hzxinquanzi.com/image/20230918/IvV36xGVibuVLT1eBTOtDsUr5iWgT95ktcNLm0X4.png"
          alt="" />
      </div>
      <div v-if="radio == 2" style="display: flex">
        <div class="img2" style="flex: 1">
          <div style="height: auto">
            <div v-for="(item, index) in share_img" :key="index" class="img2chlida">
              结果图{{ index + 1 }}
              <activityCustomUpload :formName="'url_' + index" :formValue="item" @uploadSuccess="uploadSuccess2">
              </activityCustomUpload>
              <div v-if="resultList[index]" class="reuslut_title">
                {{
                  resultList[index].score_begin != null
                    ? "得分：" +
                    resultList[index].score_begin +
                    "-" +
                    resultList[index].score_end
                    : resultList[index].title
                }}
              </div>
            </div>
          </div>

          <el-button @click="share_img.push('')" type="primary" icon="el-icon-plus" size="medium"
            style="width: 100px; margin-top: 40px">增加
          </el-button>
        </div>
        <!-- <div class="img1" style="flex:1">
        <img
          src="https://res.defen.hzxinquanzi.com/image/20230918/IvV36xGVibuVLT1eBTOtDsUr5iWgT95ktcNLm0X4.png"
          alt=""
        />
      </div> -->
        <div></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="pdataimageLiat">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量设置关联体验营" :visible.sync="dialogTableVisible" width="30%" :before-close="handleClose2">
      <span>赠送体验营设置（仅限体验营课程，支持填写0-3个）</span>
      <div class="tyy_box">
        <div class="tyyID1">
          <el-input v-model="give_camp_ids[0]" style="width: 150px"></el-input>
          <div class="tyytitle1" v-if="give_camp_list[0]">{{ give_camp_list[0].title }}</div>
          <div class="tyydata1" v-if="give_camp_list[0]">{{ give_camp_list[0].begin_at }}-{{ give_camp_list[0].end_at }}
          </div>
        </div>
        <div class="tyyID1">
          <el-input v-model="give_camp_ids[1]" style="width: 150px"></el-input>
          <div class="tyytitle2" v-if="give_camp_list[1]">{{ give_camp_list[1].title }}</div>
          <div class="tyydata2" v-if="give_camp_list[1]">{{ give_camp_list[1].begin_at }}-{{ give_camp_list[1].end_at }}
          </div>
        </div>
        <div class="tyyID1">
          <el-input v-model="give_camp_ids[2]" style="width: 150px"></el-input>
          <div class="tyytitle3" v-if="give_camp_list[2]">{{ give_camp_list[2].title }}</div>
          <div class="tyydata3" v-if="give_camp_list[2]">{{ give_camp_list[2].begin_at }}-{{ give_camp_list[2].end_at }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCommonCampIdsHadel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getappraisalList,
  setMiniprogramAddWechat,
  setappraisaupdateOnline,
  setappraisaupdatedelete,
  getMiniprogramAddWechat,
  updateShareImg,
  getresultList,
  updateCommonCampIds,
  getCommonCampInfo,
  setIsHide
} from "@/api/coupon";
import copyLink from "@/components/copymask.vue";
import activityCustomUpload from "@/components/activityCustomUpload.vue";
export default {
  data () {
    return {
      options: [],
      value: "",
      date1: "",
      date2: "",
      yeasr: "",
      page: 1,
      months: "",
      tableData: [],
      query: {
        limit: 10,
        page: 1,
        titleOrId: '',
        status: '1',
        give_camp_type: ''
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的条数
      totalItems: 0, // 列表总条数
      dataList: [], // 存储列表数据
      isOpen: true,
      online: false, // 是否上下架
      dialogVisible: false,
      radio: 1,
      share_img: [""],
      ceid: 0,
      resultList: [],
      searchID: "", // 检索id 、 title
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '上架'
      }, {
        value: '0',
        label: '下架'
      }],
      options2: [{
        value: '1',
        label: '单独'
      }, {
        value: '2',
        label: '批量'
      }],
      select1: '',
      // select2:'',
      // select3:'',
      dialogTableVisible: false,
      give_camp_ids: [],
      give_camp_list: []

    };
  },
  created () {
    this.searchData();
    this.getMiniprogram(); // 获取小程序加微开关状态
  },
  components: {
    copyLink,
    activityCustomUpload,
  },
  watch: {
    radio (newVal) {
      // 在 radio 参数发生变化时执行的操作
      console.log("radio 参数已更新:", newVal);
      this.radio = newVal;
      // 在这里进行你需要的操作，比如调用方法或发送请求等
      // ...
    },
  },
  methods: {
    setIsHide (id, is_hide) {
      console.log(id, is_hide);
      this.$confirm("是否确定将测评设置为" + (is_hide == 0 ? '显示？' : '隐藏？'), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setIsHide({
          id: id,
          is_hide: is_hide,
        }).then((response) => {
          if (response.status == 2000) {
            this.searchData();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          }
        });
      });
    },
    dialogHandel () { // 获取批量 13346 13353 13356
      this.dialogTableVisible = true
      getCommonCampInfo().then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.give_camp_ids = res.data.give_camp_list
          this.give_camp_list = res.data.give_camp_ids
        }
      })
    },
    serchListHandel () { // 搜索
      console.log(this.query, 'give_camp_type');
      this.searchData();
    },
    updateCommonCampIdsHadel () {
      let data = {
        give_camp_ids: this.give_camp_ids
      }
      updateCommonCampIds(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "恭喜你，设置成功",
            type: "success",
          });
          this.dialogTableVisible = false
          this.searchData();
        } else {
          this.$message({
            message: res.message,
            type: "info",
          });
        }
      })
    },
    dialogVisibleHandel (id) {
      const foundObject = this.tableData.find((obj) => obj.id === id);
      this.ceid = id;
      console.log(foundObject);
      this.dialogVisible = true;
      if (foundObject.share_img != null) {
        this.share_img = foundObject.share_img;
      }
      this.radio = foundObject.share_img_type;
      console.log(this.radio);
      let data = {
        test_id: id,
      };
      getresultList(data).then((res) => {
        console.log(res);
        this.resultList = res.data;
      });
    },
    handleClose2 (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    pdataimageLiat () {
      console.log(this.share_img, "share_img");
      let data = {
        id: this.ceid,
        share_img: this.share_img,
        share_img_type: this.radio,
      };
      updateShareImg(data).then((res) => {
        // console.log(res);
        if (res.code == 1) {
          this.$message({
            message: "恭喜你，保存成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.searchData();
        } else {
          return;
        }
      });
    },
    uploadSuccess2 (value) {
      let temp = value.formName.split("_");
      if (temp[0] == "url") {
        if (value.fileUrl == "") {
          this.$delete(this.share_img, temp[1]);
        } else {
          this.$set(this.share_img, temp[1], value.fileUrl);
        }
      } else {
        this.$set(this.form, value.formName, value.fileUrl);
      }
    },
    handleClose (done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    getMiniprogram () {
      //小程序加微开关状态
      let data = {};
      getMiniprogramAddWechat(data).then((res) => {
        if (res.code == 1) {
          res.data.add_wechat == "off"
            ? (this.isOpen = false)
            : (this.isOpen = true);
        }
      });
    },
    addwatchHandel () {
      // 小程序加微信开关
      var watchValue;
      if (this.isOpen) {
        watchValue = "on";
      } else {
        watchValue = "off";
      }
      let data = {
        add_wechat: watchValue,
      };
      setMiniprogramAddWechat(data).then((res) => {
        console.log(res);
      });
    },
    updateOnline (id, value) {
      // 上下架
      let data = {
        id: id,
        type: value,
      };
      setappraisaupdateOnline(data).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.searchData(); // 更新列表
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          return;
        }
      });
      console.log(id, value, data);
    },
    deleteHandel (id) {
      // 删除
      let data = {
        id: id,
      };
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setappraisaupdatedelete(data).then((res) => {
            console.log(res);
            if (res.code == 1) {
              this.searchData(); // 更新列表
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handlePageChange (currentPage) {
      // 当页码改变时，更新 currentPage 并重新获取数据
      console.log(currentPage);
      this.query.page = currentPage;
      this.searchData();
    },

    handleClick (row) {
      // 详情
      console.log(row);
      //   this.$router.push({ name: 'send_word/info', params: { id } });
      this.$router.push(`/send_word/info?id=${row.id}`);
    },
    // 列表 getcalendarlist
    searchData () {
      getappraisalList(this.query).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.totalItems = res.data.total;
        }
      });
    },
    handel (url) {
      console.log(url);
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  height: auto;
  padding: 0 30px 30px;
  box-sizing: border-box;
}

.top .el-select {
  margin-right: 30px;
}

.top {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}

.years {
  margin-right: 30px;
}

.months {
  margin-right: 30px;
}

#send_btn {
  /* margin-left: 100px; */
  margin-right: 50px;
  width: 150px;
}

.tisps {
  margin-left: 20px;
  color: #565656;
}

.send_id {
  width: 200px;
}

/* .el-table {
    border: 1px solid #ccc; 
  }
  .el-table th,
  .el-table td {
    border-width: 1px; 
    border-style: solid;
    border-color: #ccc;
  } */
.bott {
  margin: 20px auto 0;
}

.el-date-picker__header--bordered:nth-child(2) {
  display: none;
}

.el-table .cell {
  /* display: flex; */
  /* justify-content: space-around; */
  flex-wrap: nowrap;
}

.el-table .cell span {
  display: inline-block;
  /* justify-content: space-around; */
}

.el-table .cell img {
  width: 100%;
}

.el-table .cell a {
  margin: 0 5px;
}

.el-table_1_column_3 .cell {
  flex-direction: column;
}

.el-table__row .el-table_1_column_3 .cell {
  text-align: left;
}

.img1 {
  width: 310px;
  height: 570px;
  text-align: center;
  margin-top: 10px;
}

.img2 {
  display: flex;
  flex-direction: column;
}

.img1 img {
  width: 100%;
  height: 100%;
}

.img2chlida {
  width: 100px;
  height: 100px;
  float: left;
  margin: 10px;
  margin-bottom: 45px;
  text-align: center;
  position: relative;
}

.img2 .el-upload {
  width: 100px;
  height: 100px;
}

.img2 .el-upload img {
  width: 100%;
  height: 100%;
  display: block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.img2chlida .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px !important;
  min-height: 70px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}

.el-dialog__body {
  height: auto;
}

.img2chlida .el-button {
  position: absolute;
  bottom: -70px;
  left: 20px;
}

.reuslut_title {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tyyID1 {
  position: relative;
}

.tyytitle1 {
  position: absolute;
  width: auto;
  top: 0;
  left: 155px;
}

.tyydata1 {
  position: absolute;
  width: auto;
  top: 20px;
  left: 155px;
}

.tyytitle2 {
  position: absolute;
  width: auto;
  top: 0;
  left: 155px;
}

.tyydata2 {
  position: absolute;
  width: auto;
  top: 20px;
  left: 155px;
}

.tyytitle3 {
  position: absolute;
  width: auto;
  top: 0;
  left: 155px;
}

.tyydata3 {
  position: absolute;
  width: auto;
  top: 20px;
  left: 155px;
}

.res_type {
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  padding: 0 2px;
}

.Tyy_type {
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  /* background-color: coral; */
  color: #fff;
  border-radius: 5px;
  padding: 0 3px;
}

.copylink {
  margin-left: 20px;

}

.copylink .el-button {
  background-color: #F59A23;
  border-radius: 5px;
  border-color: #F59A23;
}

.bianju {
  margin: 5px;
}

.el-table .cell a {
  margin: 5px;
}
</style>